import { ChevronRight } from '@mui/icons-material';
import { Alert, AlertProps, AlertTitle, Button, Collapse } from '@mui/material';
import { Box } from '@mui/system';
import { errorStackOnly, errorToString } from '@whiz-cart/node-shared/errorToString';
import { CopyOnClick } from '@whiz-cart/ui-shared/copyOnClick/copyOnClick.component.tsx';
import { useState } from 'react';

type Props = { error?: unknown } & AlertProps;
export default function RenderError({ error, ...divProps }: Props) {
    const [open, setOpen] = useState(false);

    if (!error) {
        return null;
    }

    return (
        <Alert severity="error" {...divProps} sx={{ maxHeight: 400 }}>
            <CopyOnClick value={error instanceof Error ? error.stack : errorToString(error)}>
                <AlertTitle>
                    {divProps.children}

                    <Box
                        sx={{
                            fontWeight: 'normal',
                            whiteSpace: 'pre-wrap',

                            'p:not(:first-of-type)': {
                                ml: 2,
                            },
                        }}
                    >
                        {errorToString(error)
                            .split('\n')
                            .map((line, i) => (
                                <p key={i}>{line}&nbsp;</p>
                            ))}
                    </Box>
                </AlertTitle>

                {error instanceof Error && (
                    <>
                        <Button
                            variant="text"
                            color="inherit"
                            startIcon={
                                <ChevronRight
                                    sx={{
                                        transition: 'all 300ms',
                                        transform: `rotate3d(0, 0, 1, ${open ? '90deg' : '0'})`,
                                    }}
                                />
                            }
                            onClick={() => setOpen(!open)}
                        >
                            Stack
                        </Button>

                        <Collapse in={open}>
                            <Box
                                sx={{
                                    overflow: 'auto',
                                    display: 'grid',
                                }}
                            >
                                <Box
                                    sx={{
                                        minWidth: 0,
                                        maxHeight: '20rem',
                                        fontFamily: 'monospace',
                                        whiteSpace: 'pre',
                                        background: '@lightGrayColor',
                                    }}
                                >
                                    {errorStackOnly(error)}
                                </Box>
                            </Box>
                        </Collapse>
                    </>
                )}
            </CopyOnClick>
        </Alert>
    );
}
